// src/pages/ChapterListPage/index.js

import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { List, Typography, Card } from 'antd';
import { BookOutlined } from '@ant-design/icons';
import { getChaptersByLevel } from '../../services/exerciseService';
import { useAuth } from '../../context/AuthContext';

const { Title } = Typography;

const ChapterListPage = () => {
  const { levelId } = useParams();
  const navigate = useNavigate();
  const { userRole } = useAuth();
  const [chapters, setChapters] = useState([]);

  useEffect(() => {
    const data = getChaptersByLevel(levelId);
    setChapters(data);
  }, [levelId]);

  const handleChapterClick = (chapter) => {
    // Tên vai trò phải khớp chính xác với tên trong DB
    const isStudent = userRole?.name === '学生' || userRole?.name === 'Học sinh';

    if (isStudent && chapter.exercises && chapter.exercises.length > 0) {
      // Nếu là HỌC SINH -> đi thẳng đến bài tập đầu tiên
      const firstExerciseId = chapter.exercises[0].id;
      navigate(`/level/${levelId}/chapter/${chapter.id}/exercise/${firstExerciseId}`);
    } else {
      // Nếu là VAI TRÒ KHÁC -> vào trang danh sách bài tập
      navigate(`/level/${levelId}/chapter/${chapter.id}`);
    }
  };

  return (
    <div>
      <Title>課題一覧</Title>
      <List
        grid={{ gutter: 16, xxl: 4, xl: 3, lg: 3, md: 2, sm: 1, xs: 1 }}
        dataSource={chapters}
        renderItem={(chapter) => (
          <List.Item>
            <Card hoverable onClick={() => handleChapterClick(chapter)}>
              <Card.Meta
                avatar={<BookOutlined style={{ fontSize: '24px', color: '#1890ff' }} />}
                title={chapter.title}
                description={`${chapter.exercises.length} 問題`}
              />
            </Card>
          </List.Item>
        )}
      />
    </div>
  );
};

export default ChapterListPage;